<template>
  <div>
    <div v-show="currentStoreDoc || !isInStoreMenu">
      <overlay :isActive="showOverlay" @closed="setShowOverlay(false)"></overlay>
      <section class="container-fluid p-0">
        <slot />
      </section>
    </div>
    <!-- page-footer -->
     <div
      v-if="(!storeMenu || !getloadedMenu) && isInStoreMenu"
      class="mobile-skeleton d-flex skeleton-container mt-1"
    >
      <b-container>
        <b-row class="mt-2">
          <b-col cols="2">
            <b-skeleton type="avatar" width="50px" height="50px"></b-skeleton>
          </b-col>
          <b-col class="my-auto">
            <b-skeleton width="120px"></b-skeleton>
          </b-col>
          <b-col cols="auto">
            <b-skeleton type="button" width="125%"></b-skeleton>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-skeleton height="32px"></b-skeleton>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-skeleton width="100%" height="20px"></b-skeleton>
          </b-col>
          <b-col>
            <b-skeleton width="100%" height="20px"></b-skeleton>
          </b-col>
          <b-col>
            <b-skeleton width="100%" height="20px"></b-skeleton>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <b-skeleton width="42px"></b-skeleton>
          </b-col>
          <b-col></b-col>
          <b-col cols="auto">
            <b-skeleton width="42px"></b-skeleton>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-skeleton type="button" width="100%" height="100%"></b-skeleton>
            <b-skeleton class="mt-2" width="90%"></b-skeleton>
            <b-skeleton width="40%"></b-skeleton>
            <b-skeleton style="margin-top: 20px" width="35%"></b-skeleton>
          </b-col>
          <b-col>
            <b-skeleton type="button" width="100%" height="100%"></b-skeleton>
            <b-skeleton class="mt-2" width="90%"></b-skeleton>
            <b-skeleton width="60%"></b-skeleton>
            <b-skeleton style="margin-top: 20px" width="35%"></b-skeleton>
          </b-col>
          <b-col>
            <b-skeleton type="button" width="100%" height="100%"></b-skeleton>
            <b-skeleton class="mt-2" width="90%"></b-skeleton>
            <b-skeleton width="30%"></b-skeleton>
            <b-skeleton style="margin-top: 20px" width="35%"></b-skeleton>
          </b-col>
        </b-row>
        <b-row style="margin-top: 100px">
          <b-col>
            <b-skeleton type="input"></b-skeleton>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="8">
            <b-skeleton width="60%"></b-skeleton>
            <b-skeleton class="mt-4" width="90%"></b-skeleton>
            <b-skeleton width="100%"></b-skeleton>
            <b-skeleton class="mt-3" width="20%"></b-skeleton>
          </b-col>
          <b-col cols="4">
            <b-skeleton type="button" width="100%" height="100%"></b-skeleton>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="8">
            <b-skeleton width="60%"></b-skeleton>
            <b-skeleton class="mt-4" width="90%"></b-skeleton>
            <b-skeleton width="100%"></b-skeleton>
            <b-skeleton class="mt-3" width="20%"></b-skeleton>
          </b-col>
          <b-col cols="4">
            <b-skeleton type="button" width="100%" height="100%"></b-skeleton>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="8">
            <b-skeleton width="60%"></b-skeleton>
            <b-skeleton class="mt-4" width="90%"></b-skeleton>
            <b-skeleton width="100%"></b-skeleton>
            <b-skeleton class="mt-3" width="20%"></b-skeleton>
          </b-col>
          <b-col cols="4">
            <b-skeleton type="button" width="100%" height="100%"></b-skeleton>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import overlay from "./overlay.vue";

export default {
  components: {
    overlay
  },
  created() {
    this.isInStoreMenu = !!this.$route.matched.find((route) => {
      return route.name === "store";
    });
  },
   data() {
    return {
      isInStoreMenu: false,
    };
  },
  computed: {
    ...mapGetters([
      "showOverlay",
      "currentStoreDoc",
      "storeMenu",
      "getloadedMenu",
    ]),
  },
  watch: {
    $route () {
      this.isInStoreMenu = !!this.$route.matched.find((route) => {
        return route.name === "store";
      });
    },
  },
  methods: {
    ...mapMutations(["setShowOverlay"]),
  },
};
</script>
<style scoped>
  .skeleton-container {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  .store-loading{
    width: 80%;
    border-radius: 10px;
  }
</style>